























import Vue from "vue"
import FloatingButton from "~/components/guideline/button/FloatingButton.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"
import PPaidPlanContractGuidanceForProjectModal from "~/components/custom/corporationContract/PPaidPlanContractGuidanceForProjectModal.vue"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"

export default Vue.extend({
  components: {
    FloatingButton,
    MaterialIcon,
    PPaidPlanContractGuidanceForProjectModal,
  },
  data() {
    return {
      isVisibleSubscriptionGuidanceModal: false,
    }
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
    isAbleToCreateProject(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.PROJECT_CREATE)
    },
    shouldApealPaidPlanContract(): boolean {
      return this.$clStores.corporationContractAppeal.getters
        .shouldApealPaidPlanContract
    },
  },
  mounted() {
    this.$clStores.corporationContractAppeal.actions.refresh()
  },
  methods: {
    createNewProject() {
      if (!this.isAbleToCreateProject) {
        this.openSubscriptionGuidanceModal()
        return
      }

      this.$nuxt.$router.push({
        path: "/corporation/projects/new/title",
      })
    },
    closeSubscriptionGuidanceModal() {
      this.isVisibleSubscriptionGuidanceModal = false
    },
    openSubscriptionGuidanceModal() {
      this.isVisibleSubscriptionGuidanceModal = true
    },
  },
})
